import type { CSSProperties, ReactNode } from "react";
import { usePhone, useRail } from "./media";

/**
 * List beside detail on an iPad: the list on the left, the picked thing on the right, each scrolling on its
 * own and each drawn as a phone screen. On a phone only one shows: the detail when `showDetail`, else the
 * list. A computer shows `wide` when the page gives one (its own layout), else the same two panes.
 */
export function Split({
  list,
  detail,
  showDetail,
  wide,
  listWidth = 340,
}: {
  list: ReactNode;
  detail: ReactNode;
  showDetail: boolean;
  wide?: ReactNode;
  listWidth?: number;
}) {
  const phone = usePhone();
  const rail = useRail();
  if (phone) return <>{showDetail ? detail : list}</>;
  if (!rail && wide !== undefined) return <>{wide}</>;
  return (
    <div className="pn-split" style={{ "--pn-list": `${listWidth}px` } as CSSProperties}>
      <div className="pn-pane pn-pane-list">{list}</div>
      <div className="pn-pane pn-pane-detail">{detail}</div>
    </div>
  );
}
